import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PreFooterCallout from '../components/PreFooterCallout';
import { imageUrl } from '../lib/images';

const STATIC_POSTS = {
  'eksempel-paa-indlaeg-3': {
    title: 'Eksempel på indlæg',
    metaTitle: 'Eksempel på indlæg - Advokatfirmaet Kopp',
    metaDescription:
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
    paragraphs: [
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes. Cu quem ubique regione sed, ne quodsi commune forensibus his. Tollit graeci duo eu, an pri albucius prodesset. Utamur numquam consectetuer has eu.',
      'In vim velit facete praesent. Vel ex mucius labore molestie, te mea alii persequeris definitionem. An amet ceteros pro, salutandi vituperata ad pri. Te homero probatus concludaturque his, ei mea vide deseruisse interesset. Te adhuc principes mea, vim ut wisi vocent legendos.',
    ],
    billede: 'custom-size-6.jpg',
  },
  'eksempel-paa-indlaeg-2-2': {
    title: 'Eksempel på indlæg',
    metaTitle: 'Eksempel på indlæg - Advokatfirmaet Kopp',
    metaDescription:
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
    paragraphs: [
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes. Cu quem ubique regione sed, ne quodsi commune forensibus his. Tollit graeci duo eu, an pri albucius prodesset. Utamur numquam consectetuer has eu.',
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes. Cu quem ubique regione sed, ne quodsi commune forensibus his. Tollit graeci duo eu, an pri albucius prodesset. Utamur numquam consectetuer has eu.',
    ],
    billede: 'custom-size-6.jpg',
  },
  'eksempel-paa-indlaeg-2-2-2': {
    title: 'Eksempel på indlæg',
    metaTitle: 'Eksempel på indlæg - Advokatfirmaet Kopp',
    metaDescription:
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
    paragraphs: [
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes. Cu quem ubique regione sed, ne quodsi commune forensibus his. Tollit graeci duo eu, an pri albucius prodesset. Utamur numquam consectetuer has eu.',
      'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes. Cu quem ubique regione sed, ne quodsi commune forensibus his. Tollit graeci duo eu, an pri albucius prodesset. Utamur numquam consectetuer has eu.',
    ],
    billede: 'custom-size-6.jpg',
  },
};

export default function NyhedDetail({ fixedSlug }) {
  const { slug } = useParams();
  const currentSlug = fixedSlug || slug?.replace(/\/+$/, '') || 'eksempel-paa-indlaeg-3';
  const post = STATIC_POSTS[currentSlug] || STATIC_POSTS['eksempel-paa-indlaeg-3'];

  return (
    <div>
      <SEO
        title={post.metaTitle}
        description={post.metaDescription}
        ogImage={imageUrl(post.billede)}
      />

      <article className="w-full bg-white py-16 lg:py-24 px-6 lg:px-12 border-b border-slate-200">
        <div className="max-w-3xl mx-auto space-y-8">
          <div>
            <Link
              to="/nyheder/"
              className="inline-flex items-center space-x-2 text-xs font-semibold uppercase tracking-wider text-slate-500 hover:text-[#1c3848] mb-6"
            >
              <i className="fa-solid fa-arrow-left text-[10px]" aria-hidden="true" />
              <span>Tilbage til nyheder</span>
            </Link>
            <h1 className="text-3xl lg:text-4xl font-bold text-[#1c3848]">
              {post.title}
            </h1>
          </div>

          <div className="aspect-16/9 w-full overflow-hidden bg-slate-100 shadow-sm">
            <img
              src={imageUrl(post.billede, 'width=1000,height=560,fit=cover,quality=85,format=auto')}
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>

          <div className="space-y-4 text-sm sm:text-base text-slate-700 leading-relaxed pt-2">
            {post.paragraphs.map((p, idx) => (
              <p key={idx}>{p}</p>
            ))}
          </div>
        </div>
      </article>

      <PreFooterCallout />
    </div>
  );
}
